import { Specialist } from "~/types/specialist";
import { dateFormat } from "~/helpers/date";
import {
  isPublicFormat,
  sexFormat,
  businessFormat,
  prefectureFormat,
  contactFormat,
} from "../helpers/format";
import { MasterState } from "~/redux/modules/master";

type Column = {
  id: keyof Specialist;
  label: string;
  minWidth?: number;
  // eslint-disable-next-line no-unused-vars
  format?: (_: any) => string;
};

export const getColumns = (master: MasterState): Column[] => [
  {
    id: "isPublic",
    label: "状態",
    minWidth: 50,
    format: isPublicFormat,
  },
  { id: "email", label: "メールアドレス", minWidth: 160 },
  { id: "lastName", label: "苗字(漢字)", minWidth: 80 },
  { id: "firstName", label: "名前(漢字)", minWidth: 80 },
  { id: "lastNameKana", label: "苗字(カタカナ)", minWidth: 100 },
  { id: "firstNameKana", label: "名前(カタカナ)", minWidth: 100 },
  { id: "sex", label: "性別", minWidth: 60, format: sexFormat },
  {
    id: "business",
    label: "業態",
    minWidth: 140,
    format: (val: number) => businessFormat(val, master),
  },
  {
    id: "prefecture",
    label: "活動エリア",
    minWidth: 100,
    format: (val) => prefectureFormat(val, master),
  },
  { id: "company", label: "所属(企業、団体名)", minWidth: 140 },
  { id: "address", label: "事務所の住所", minWidth: 200 },
  {
    id: "contactMethod1",
    label: "連絡手段①",
    minWidth: 100,
    format: (val: number) => contactFormat(val, master),
  },
  { id: "contact1", label: "連絡手段①の連絡先", minWidth: 160 },
  {
    id: "contactMethod2",
    label: "連絡手段②",
    minWidth: 100,
    format: (val: number) => contactFormat(val, master),
  },
  { id: "contact2", label: "連絡手段②の連絡先", minWidth: 160 },
  { id: "introduction", label: "自己紹介文", minWidth: 400 },
  { id: "created", label: "登録日", minWidth: 220, format: dateFormat },
];
